const submitPPERequest = async (form: any, version2?: boolean) => {
  const url = `${process.env.NEXT_PUBLIC_REDIRECT_URL}api/landing/ppequote${version2 ? "-v2" : ""}`;
  const data = form;
  const props = fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  })
    .then(response => response.json())
    .then(response => {
      const success = response?.success || false;
      return {
        success,
      }
    })
    .catch(error => {
      // handle error
      // eslint-disable-next-line no-console
      console.error(error);
      return {
        success: false,
      }
    });
  return props;
}

export default submitPPERequest;